import { render, staticRenderFns } from "./ReservedList.vue?vue&type=template&id=24dbb6dc&scoped=true&lang=pug"
import script from "./ReservedList.vue?vue&type=script&lang=js"
export * from "./ReservedList.vue?vue&type=script&lang=js"
import style0 from "./ReservedList.vue?vue&type=style&index=0&id=24dbb6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dbb6dc",
  null
  
)

export default component.exports